import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '@/lib/api';
import type { CalculatorsProfile, ProfileList } from '@/lib/types';

/**
 * The calculator bundle a fleet is running.
 *
 * Read through `resolved`, not through the stored override: what an operator
 * needs to see is what the engine will actually use — the shipped defaults with
 * this organisation's changes already applied. The override on its own is a
 * diff against something invisible.
 */
export function useCalculators() {
  return useQuery({
    queryKey: ['calculators'],
    queryFn: () => apiFetch<ProfileList>('/v1/analysis-profiles?kind=calculators'),
    staleTime: 30 * 1000,
  });
}

export function useSaveCalculators() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (config: CalculatorsProfile) =>
      apiFetch('/v1/analysis-profiles', {
        method: 'PUT',
        body: JSON.stringify({ kind: 'calculators', scope: 'ORGANIZATION', config }),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['calculators'] }),
  });
}
